var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgOnoz = function SvgOnoz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 96,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m122.621 94.574-11.943-9.157H20.905A14.271 14.271 0 0 1 6.573 71.085V19.332A14.272 14.272 0 0 1 20.905 5h95.744a14.269 14.269 0 0 1 13.257 8.838 14.26 14.26 0 0 1 1.075 5.494v70.863a5.109 5.109 0 0 1-2.723 4.97 5.115 5.115 0 0 1-5.637-.591Z",
    fill: "#C3DDFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m117.048 90.574-11.943-9.157H15.332A14.271 14.271 0 0 1 1 67.085V15.332A14.272 14.272 0 0 1 15.332 1h95.943a14.272 14.272 0 0 1 14.332 14.332v70.863a5.31 5.31 0 0 1-2.891 4.903 5.315 5.315 0 0 1-5.668-.524v0Z",
    stroke: "#1D4ED8",
    strokeWidth: 1.705,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.99 52.157a18.313 18.313 0 0 1 36.627 0M23.294 33.844a4.777 4.777 0 0 1 9.555 0M93.758 33.844a4.777 4.777 0 1 1 9.555 0",
    stroke: "#1D4ED8",
    strokeWidth: 1.705,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgOnoz;